import React from 'react';
import Container from "react-bootstrap/Container";
const Tools = () => <Container id="MEDCAL_RX_TOOLS_PAGE"><h1 id="MEDCAL_RX_TOOLS_HEADER">Tools</h1></Container>;
export default Tools;
